module.exports = __webpack_public_path__ + "static/media/1.e4e86346.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/novopolotsk/1.jpg
// module id = 243
// module chunks = 0